export const getTokenParams = function(
  user = 'adminzh',
  pass = '0F228B983BB984517CCF0D9AA4AA9B14'
) {
  return [
    {
      Value: 'TBaseDM',
      Type: 4,
      Name: '{9F8E5ECB-5976-4315-B8F3-43B8502B694D}'
    },
    {
      Value: user,
      Type: 4,
      Name: 'User'
    },
    {
      Value: pass,
      Type: 4,
      Name: 'Pass'
    },
    {
      Value: 'Test1',
      Type: 4,
      Name: '{2881E26D-62CE-4937-B4BB-8998440417C4}'
    }
  ]
}

export const getUserParams = function(
  token,
  userId,
  userName,
  email,
  enterprise
) {
  return [
    {
      Value: 'TUserDM',
      Type: 4,
      Name: '{9F8E5ECB-5976-4315-B8F3-43B8502B694D}'
    },
    {
      Value: token,
      Type: 4,
      Name: 'Token'
    },
    {
      Value: true,
      Type: 1,
      Name: 'IsNew'
    },
    {
      Value: 'FA00A9B41ED54B44A9EAE83A9031E36F',
      Type: 4,
      Name: 'PID'
    },
    {
      Value: userId,
      Type: 4,
      Name: 'UserID'
    },
    {
      Value: userName,
      Type: 4,
      Name: 'UserName'
    },
    {
      Value: 1,
      Type: 0,
      Name: 'Enabled'
    },
    {
      Value: email,
      Type: 4,
      Name: 'eMail'
    },
    {
      Value: enterprise,
      Type: 4,
      Name: 'WeChat'
    },
    {
      Value: 'C4CA4238A0B923820DCC509A6F75849B',
      Type: 4,
      Name: 'Pass'
    },
    {
      Value: 'C4CA4238A0B923820DCC509A6F75849B',
      Type: 4,
      Name: 'PassEx'
    },
    {
      Value: 'C4CA4238A0B923820DCC509A6F75849B',
      Type: 4,
      Name: 'PassWord'
    },
    {
      Value: 'SetUserInfo',
      Type: 4,
      Name: '{2881E26D-62CE-4937-B4BB-8998440417C4}'
    }
  ]
}

export const getRoleParams = function(token, loginId) {
  return [
    {
      Value: token,
      Type: 4,
      Name: 'Token'
    },
    {
      Type: 4,
      Value: 'TUserDM',
      Name: '{9F8E5ECB-5976-4315-B8F3-43B8502B694D}'
    },
    {
      Type: 4,
      Value: 'SetUserRole',
      Name: '{2881E26D-62CE-4937-B4BB-8998440417C4}'
    },
    {
      Type: 4,
      Value: loginId,
      Name: 'LoginID'
    },
    {
      Type: 4,
      Value: '65DE48C8915A4C1EB5A17B17DDDE7EFE',
      Name: 'RoleID'
    }
  ]
}

export default {
  getTokenParams,
  getUserParams,
  getRoleParams
}
